// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2cbhT","title":"AfterFrontImage_title__3c-0Q"};